import { Link } from "react-router-dom";

import { useTranslation } from 'react-i18next';
export default function ComparisonCTA({ competitor, honestNote, whyChooseReasons, cta }) {
  const { t } = useTranslation();
  // Support both old prop style (honestNote, whyChooseReasons) and new cta prop
  const primaryText = cta?.primary || "Start Free Trial";
  const primaryLink = cta?.primaryLink || "/pricing";
  const secondaryText = cta?.secondary || "Talk to Sales";
  const secondaryLink = cta?.secondaryLink || "/contact";

  return (
    <>
      {/* Why Choose Max OS — only if whyChooseReasons provided */}
      {whyChooseReasons && (
        <section className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
          <div className="text-center mb-12">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500 mb-6">
              // WHY CHOOSE MAX OS
            </div>
            <h2 className="font-display text-3xl md:text-5xl uppercase leading-[0.95] max-w-3xl mx-auto">
              Why businesses choose
              <br />
              <span className="text-amber-500">{t('comparison_c_t_a.max_os_cloud')}</span> over {competitor}
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            {whyChooseReasons.map((reason, idx) => (
              <div key={idx} className="flex items-start gap-4 bg-zinc-950/60 border border-zinc-800 p-6">
                <svg className="w-5 h-5 text-amber-500 mt-0.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
                <div>
                  <p className="text-white font-medium mb-1">{reason.title}</p>
                  <p className="text-zinc-400 text-sm leading-relaxed">{reason.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* Honest note — only if provided as direct prop */}
      {honestNote && !cta && (
        <section className="max-w-3xl mx-auto px-6 lg:px-12 py-8">
          <div className="border border-zinc-800 bg-zinc-950/40 p-8 text-center">
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-3">{t('comparison_c_t_a.honest_take')}</p>
            <p className="text-zinc-300 leading-relaxed italic">&ldquo;{honestNote}&rdquo;</p>
          </div>
        </section>
      )}

      {/* Final CTA */}
      <section className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="relative overflow-hidden border border-zinc-800 bg-gradient-to-br from-zinc-950 to-zinc-900 p-8 lg:p-16 text-center">
          <div className="absolute top-0 right-0 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl" aria-hidden="true" />
          <div className="relative">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500 mb-6">
              // READY TO GET STARTED?
            </div>
            <h2 className="font-display text-3xl lg:text-5xl text-white uppercase leading-tight mb-6">
              Experience the
              <br />
              <span className="text-amber-500">{t('comparison_c_t_a.max_os_difference')}</span>
            </h2>
            <p className="text-zinc-400 max-w-xl mx-auto mb-8 leading-relaxed">
              Start your 7-day free trial. Credit card required. Cancel anytime for a full refund.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <Link
                to={primaryLink}
                className="bg-amber-500 hover:bg-amber-400 text-black px-8 py-4 font-bold uppercase tracking-wider text-sm transition-colors"
              >
                {primaryText}
              </Link>
              <Link
                to={secondaryLink}
                className="border border-zinc-700 hover:border-amber-500 text-zinc-300 hover:text-amber-500 px-8 py-4 font-mono text-xs uppercase tracking-[0.15em] transition-colors"
              >
                {secondaryText}
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
